import * as React from "react";
const SvgSecuritySmall = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.58 1.191a.75.75 0 0 0-1.16 0c-.587.717-1.462 1.487-2.448 2.113-.99.629-2.04 1.08-2.969 1.214-.665.096-1.298.652-1.298 1.45 0 4.024 1.74 7.85 4.773 10.495l2.03 1.769a.75.75 0 0 0 .985 0l2.029-1.769a13.924 13.924 0 0 0 4.773-10.495c0-.797-.632-1.352-1.29-1.453-.872-.134-1.906-.564-2.904-1.18-.994-.615-1.898-1.383-2.52-2.144ZM4.218 6.002c1.208-.175 2.46-.735 3.558-1.432A12.785 12.785 0 0 0 10 2.785a12.629 12.629 0 0 0 2.312 1.825c1.103.683 2.33 1.213 3.464 1.387a.07.07 0 0 1 .02.007 12.424 12.424 0 0 1-4.26 9.328L10 16.672l-1.536-1.34a12.424 12.424 0 0 1-4.26-9.326.06.06 0 0 1 .014-.004Zm9.713 2.151a.75.75 0 0 0-1.12-.996l-3.36 3.78-1.378-1.328a.75.75 0 0 0-1.04 1.08l1.939 1.87a.75.75 0 0 0 1.08-.042l3.88-4.364Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgSecuritySmall;
